import { useState, useEffect } from 'react'

const usePdfData = (path) => {
  const [pdfData, setPdfData] = useState(null)

  useEffect(() => {
    const loadPdf = async () => {
      const response = await fetch(path)
      const blob = await response.blob()
      setPdfData(blob)
    }
    loadPdf()
  }, [])

  return pdfData
}

export default usePdfData
